import { render, staticRenderFns } from "./IconLights.vue?vue&type=template&id=e55aaa98&scoped=true&"
import script from "./IconLights.vue?vue&type=script&lang=ts&"
export * from "./IconLights.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55aaa98",
  null
  
)

export default component.exports